import React from 'react';

const Header = () => {
    return (
        <div style={{textAlign: "center"}}>
            <h1>Code<span style={{color:'#425e9c'}}>Forces</span> Top C<span style={{color:'#ff0000'}}>ontestents</span></h1>
        </div>
    );
};

export default Header;